var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-369 -162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5409 2.40625 15.5409 2.40625C16.8695 6.64709 19.6938 9.99109 23.2753 11.5641L23.2753 11.5641C19.6938 13.1371 16.8695 16.4797 15.5409 20.7219L15.5409 20.7219C14.212 16.4811 11.3881 13.1371 7.80656 11.5641L7.80656 11.5641C11.3881 9.99109 14.212 6.64709 15.5409 2.40625Z",
    fill: "#FFFFFF",
    transform: "matrix(1.0303 0 0 1 369 162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2427 18.0696 23.2427 18.0696C24.1512 20.9688 26.0824 23.2557 28.5312 24.3317L28.5312 24.3317C26.0824 25.4073 24.1512 27.6939 23.2427 30.5938L23.2427 30.5938C22.3341 27.6939 20.4029 25.4073 17.9541 24.3317L17.9541 24.3317C20.4029 23.2557 22.3341 20.9688 23.2427 18.0696Z",
    fill: "#FFFFFF",
    transform: "matrix(1.0303 0 0 1 369 162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55112 18.2552 8.55112 18.2552C9.05187 20.0217 10.2889 21.4871 11.9463 22.2771L11.9463 22.2771C10.2893 23.0666 9.05231 24.5311 8.55112 26.2969L8.55112 26.2969C8.05059 24.5304 6.81364 23.065 5.15625 22.275L5.15625 22.275C6.81319 21.4853 8.05007 20.0207 8.55112 18.2548Z",
    fill: "#FFFFFF",
    transform: "matrix(1.0303 0 0 1 369 162)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarketplace);
export default __webpack_public_path__ + "static/media/icon-marketplace.1066048f2dd74f3e60e7fbd0fa7b482d.svg";
export { ForwardRef as ReactComponent };